/** @name 项目角色大屏 */
export const SCREEN_PROJECT_ROLE = 'SCREEN_PROJECT_ROLE';
/** @name 区域运维大屏 */
export const SCREEN_AREA = 'SCREEN_AREA';
